export const DEFAULT_CART_ERROR_MESSAGES = {
  NotActive: `Your order does not qualify for this promotion.`,
  NotValid: `This promotion has expired.`,
  noInventory: `is no longer available and has been removed from your cart.`,
  qtyAdjustedPart1: `Quantity of`,
  qtyAdjustedPart2: `has been adjusted - only`,
  qtyAdjustedPart3: `currently available`,
};
